export { BvlPaginatorComponent as BvlPaginator } from './paginator.component';
export { BvlPaginatorModule } from './paginator.module';
